import axios from 'axios'
import domMessage from './MessageOnce'
import { Loading } from 'element-ui'
let Message = null //new domMessage()
import router from '@/router/index'
import { getToken, getTokenName } from '@/utils/auth'
import global from '@/global'
let loading

function startLoading() {
  loading = Loading.service({
    lock: true,
    text: '加载中……',
    background: 'rgba(0, 0, 0, 0.7)',
    fullscreen: true
  })
  let BOX = document.querySelector('.el-loading-mask')
  BOX.style.zIndex = '9999'
}
function endLoading() {
  setTimeout(() => {
    loading.close()
  }, 250)
}
let needLoadingRequestCount = 0
export function showFullScreenLoading() {
  if (needLoadingRequestCount === 0) {
    startLoading()
  }
  needLoadingRequestCount++
}

export function tryHideFullScreenLoading() {
  if (needLoadingRequestCount <= 0) return
  needLoadingRequestCount--
  if (needLoadingRequestCount === 0) {
    endLoading()
  }
}

//http request 拦截器
const service = axios.create({
  baseURL: window.ajaxYSUrl, // api 的 base_url//此处注释，在main中的ajaxBaseUrl存在异步，在下面赋值
  timeout: 300000 // request timeout
})

service.defaults.withCredentials = true
service.interceptors.request.use(
  config => {
    let token = getToken()
    let name = getTokenName()
    if (name) {
      config.headers[name] = token
    }

    if (!config.headers['Content-Type']) {
      if (config.method == 'post') {
        config.headers['Content-Type'] = 'application/json'
      } else if (config.method == 'get') {
        config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
      }
    }
    if (config.url == '/counterCharges/calculatePrice') {
      window.stop()
    }
    // config.url = window.ajaxBaseUrl + config.url //ajaxBaseUrl 在此处赋值。
    // if (config.prefix) {
    //   config.url = global[config.prefix] + config.url
    // } else {
    //   config.url = global.gasGis + config.url
    // }

    // } else if (config.method == 'get') {
    //   let url = config.url.split('/')
    //   if(url[2] == 'ExportFile') {
    // 		config.headers['Content-Type'] = 'multipart/form-data'
    // 	}else{
    //     config.headers = {
    //       'gas-rqjt-token': '7a89206c-454d-40b1-a7f1-df5d9b33f055'
    //     }
    //   }
    // }
    if (!config.isShowLoding) {
      showFullScreenLoading()
    }
    return config
  },
  error => {
    return Promise.reject(err)
  }
)
service.interceptors.response.use(
  response => {
    tryHideFullScreenLoading()

    Message = new domMessage()
    if (response.data.code == -104) {
      Message.error(response.data.msg)
      router.push('/login').catch(err => {})
      // if (getLoginUrl()) {
      //   window.location.href = getLoginUrl()
      // } else {
      //   router.push('/login').catch(err => { })
      // }
      return Promise.reject()
    } else if (response.data.code == 200) {
      return response.data
    } else if (response.data.code == 1001) {
      Message.error(response.data.errorMsg)
      return response.data
    } else if (response.data && response.data.code) {
      if (response.data.data) {
        Message.error(response.data.msg || response.data.errorMsg)
        return response.data
      } else if (response.data.code == '-304') {
        Message.error(response.data.msg)
        return response.data
      } else {
        Message.error(response.data.msg)
        return Promise.reject()
      }
    } else {
      return response.data
    }
  },
  error => {
    tryHideFullScreenLoading()
    return Promise.reject(error)
  }
)

export default service
